import React from "react";
import {
  useDispatch,
  useMappedState
} from "redux-react-hook";
import _ from "lodash";

import { IStore } from "src/core/shared/store";
import { addLatestPackSize } from "src/core/shared/store/global/global.actions";

import { IProduct } from "../api/products.api";

export const useProductLatestPackSize = (product?: IProduct | null) => {
  const { latestPackSizes } = useMappedState(({ global }: IStore) => ({ latestPackSizes: global.latestPackSizes }));
  const dispatch = useDispatch();

  const packSize = React.useMemo(() => {
    if (product) {
      const latestPackSize = latestPackSizes?.find(latestPackSize => latestPackSize.partNumber === product.partNumber);

      if (latestPackSize) {
        return (product.packSizes || []).find(packSize => packSize.code === latestPackSize?.packSizeCode);
      } else if (product.disableUnitOrdering) {
        return _.sortBy(product.packSizes || [], "quantity")[ 0 ];
      }
    }

    return null;
  }, [ latestPackSizes, product ]);

  const getPackSizeByProduct = React.useCallback((product: IProduct | null) => {
    if (product) {
      const latestPackSize = latestPackSizes?.find(latestPackSize => latestPackSize.partNumber === product.partNumber);

      return (product.packSizes || []).find(packSize => packSize.code === latestPackSize?.packSizeCode);
    }

    return null;
  }, [ latestPackSizes ]);

  return [
    {
      packSize,
      packSizes: product?.packSizes
    },
    {
      setPackSize: (packSizeCode: string | null) => {
        dispatch(addLatestPackSize({
          partNumber: product?.partNumber as string,
          packSizeCode
        }));
      },
      getPackSizeByProduct
    }
  ];
};
